export default "__VITE_ASSET__CIcBHxY9__"